var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#FFF7DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12570_35571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5047 17.6501C18.4064 17.6501 19.2712 17.2919 19.9089 16.6543C20.5465 16.0166 20.9047 15.1518 20.9047 14.2501C20.9047 13.3484 20.5465 12.4836 19.9089 11.8459C19.2712 11.2083 18.4064 10.8501 17.5047 10.8501C16.603 10.8501 15.7381 11.2083 15.1005 11.8459C14.4629 12.4836 14.1047 13.3484 14.1047 14.2501C14.1047 15.1518 14.4629 16.0166 15.1005 16.6543C15.7381 17.2919 16.603 17.6501 17.5047 17.6501ZM16.2908 18.9251C13.6744 18.9251 11.5547 21.0448 11.5547 23.6612C11.5547 24.0968 11.908 24.4501 12.3436 24.4501H22.6658C23.1014 24.4501 23.4547 24.0968 23.4547 23.6612C23.4547 21.0448 21.335 18.9251 18.7186 18.9251H16.2908Z",
    fill: "#F8B900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12570_35571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9,
    height: 13.6,
    fill: "white",
    transform: "translate(11.5508 10.8499)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.c97fed3731408d7a87b9003cc3e0a462.svg";
export { ForwardRef as ReactComponent };